import { useEffect, useState } from 'react';
import { getCurrentUser } from '@agilytics/utils/jira';
import { useAgilyticsState } from '@agilytics/global-state';

export default function useProjects(query) {
  const { accessToken, cloudId } = useAgilyticsState();
  const [user, setUser] = useState({});

  useEffect(() => {
    if (accessToken && cloudId) {
      const fetchUser = async () => {
        const currentUser = await getCurrentUser(accessToken, cloudId);
        setUser(currentUser);
      };

      fetchUser();
    }
  }, [accessToken, cloudId, setUser]);

  return user;
}
